import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'vbExcludeSecondsFromTimespan',
	standalone: false
})
export class VbExcludeSecondsFromTimespanPipe implements PipeTransform {
	public transform(formattedTimespan: string): string {
		return formattedTimespan.substring(0, formattedTimespan.lastIndexOf(':'));
	}
}
